import { API } from '@/plugins/api'
import { hamiVuex } from '@/store/base'
import Vue from 'vue'
import { projectStore } from './project'
import _ from 'lodash'

export const equityStore = hamiVuex.store({
  $name: 'equity',
  $state: {
    equityMap: {},
    equityGroupMap: {},
    isReady: false,
  },
  get list() {
    return _.sortBy(Object.values(this.equityMap), ['index', 'dt_created'])
  },
  get _groupAndEquityMap() {
    let groupList = _.sortBy(Object.values(this.equityGroupMap), ['is_virtual', 'name'])
    let resultMap = {}
    groupList.forEach(group => {
      let equityList = this.list.filter(x => x.group_id === group.id)
      if (!group.is_virtual || equityList.length > 0) {
        resultMap[group.id] = { group, equityList }
      }
    })
    return resultMap
  },
  get groupList() {
    return Object.values(this._groupAndEquityMap).map(x => x.group)
  },
  get(id) {
    return this.equityMap[id]
  },
  getGroup(id) {
    return this.equityGroupMap[id]
  },
  listOfGroup(group_id) {
    return this._groupAndEquityMap[group_id]?.equityList || []
  },
  UPSERT(item) {
    this.$patch(state => {
      Vue.set(state.equityMap, item.id, item)
    })
  },
  DELETE(id) {
    this.$patch(state => {
      Vue.delete(state.equityMap, id)
    })
  },
  LOAD_GROUP_LIST({ addList, delGroupIdList }) {
    const equityGroupMap = { ...this.equityGroupMap }
    const equityMap = { ...this.equityMap }
    ;(delGroupIdList || []).forEach(groupId => {
      if (!_.isNil(groupId) && groupId !== '') {
        delete equityGroupMap[groupId]
      }
    })
    ;(addList || []).forEach(item => {
      equityGroupMap[item.id] = item
      ;(item.equity_s || []).forEach(equity => {
        equityMap[equity.id] = equity
      })
    })
    this.$patch(state => {
      state.equityGroupMap = equityGroupMap
      state.equityMap = equityMap
      state.isReady = true
    })
  },
  doLoad: _.once(async function doLoad() {
    const payload = {
      project_id: projectStore.currentId,
    }
    let result = await API.call('merchant/equity.query_group', payload)
    this.LOAD_GROUP_LIST({ addList: result.item_s })
  }),
  async doSaveGroup({ id, name }) {
    let result
    let payload = { name, project_id: projectStore.currentId }
    if (_.isNil(id) || id === '') {
      result = await API.call('merchant/equity.create_group', payload)
    } else {
      payload.id = id
      result = await API.call('merchant/equity.update_group', payload)
    }
    this.LOAD_GROUP_LIST({ addList: [result] })
    return result
  },
  async doDeleteGroup({ id }) {
    let updateItem = this.equityGroupMap[id]
    await API.call('merchant/equity.delete_group', {
      id,
      project_id: projectStore.currentId,
    })
    if (!_.isNil(updateItem)) {
      this.LOAD_GROUP_LIST({ delGroupIdList: [id] })
    }
  },
  async doSave(payload) {
    let isCreate = _.isNil(payload.id) || payload.id === ''
    payload.project_id = projectStore.currentId
    let result
    if (isCreate) {
      result = await API.call('merchant/equity.create', payload)
    } else {
      result = await API.call('merchant/equity.update', payload)
    }
    this.UPSERT(result)
    return result
  },
  async doDelete(id) {
    const payload = {
      id: id,
      project_id: projectStore.currentId,
    }
    await API.call('merchant/equity.delete', payload)
    this.DELETE(id)
  },
})
